import React, { useState, useEffect } from "react";
import { fetchTicketStatus } from "src/apis/tickets";
import { useNavigate, useRouteLoaderData, defer } from "react-router-dom";
import ButtonPolicy from "src/components/Permission/ButtonPolicy";
import "./Board.css";
import {
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import Ticket from "src/components/TicketingComponents/TicketForm";
import ReassignTicket from "./reassignTicket";
import { UpdateTicketState } from "src/util/ChangeTicketState";
import { useAlertContext } from "src/hooks/use-alert";
import { useRoleContext } from "src/hooks/use-alert";
import { updateTicketStatus } from "src/apis/tickets";
import ProposeFee from "./proposeFeeForm";
import moment from "moment";
import TicketFilter from "./TicketFilter";
import DailogContainer from "../DailogContainer";
import { TicketStatus, ticketStatuses } from "src/util/utility_enums";
import { set } from "date-fns";

const TicketingPage = () => {
  const [isFeeDialogOpen, setIsFeeDialogOpen] = useState(false); // State to control the dialog
  const [fee, setFee] = useState(null);
  const [ticketToSolve, setTicketToSolve] = useState(null);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [showNewTicketForm, setShowNewTicketForm] = useState(false);
  const [showReassignTicketForm, setshowReassignTicketForm] = useState(false);
  const [showTicketDetails, setShowTicketDetails] = useState(false);
  const [selectedTicketDetails, setSelectedTicketDetails] = useState(null);
  const [sortOption, setSortOption] = useState("date");
  const [filterDialogOpen, setFilterDialogOpen] = useState(false);
  const [tickets, setTickets] = useState([]);
  const [buildings, setBuildings] = useState([]);
  const [sites, setSites] = useState([]);
  const [assets, setAssets] = useState([]);
  const [operators, setOperators] = useState([]);
  const [mntEmails, setMntEmails] = useState([]);
  const alert = useAlertContext();
  const [detailOpen, setDetailOpen] = useState(false);
  const [detailText, setDetailText] = useState("");
  const [detailTicket, setDetailTicket] = useState(null);
  const [regress,setRegress]=useState(false); 
  useEffect(() => {
   
    if (alert.ticketUpdate && alert.ticketUpdate.fatherId) { 
      {/*upon recieval of succesful ticket update message change the ticket status using fatherId  */}
      const newState = tickets.map((obj) => {
        // 👇️ if id equals id in event, update the status property
        if (obj.father === parseInt(alert.ticketUpdate.fatherId)) {
          const index = parseInt(alert.ticketUpdate.status);
          return { ...obj, actualStatus: ticketStatuses[index - 1].name };
        }
        return obj;
      });
      setTickets(newState);
    }
  }, [ alert.ticketUpdate]);

useEffect(()=>{
    if(alert.newTicket && alert.newTicket.newTicket){
      console.log(alert.newTicket.newTicket)
      const newTickets=[ ...tickets, alert.newTicket.newTicket]
      setTickets(newTickets);
  }
   

  alert.setNewTicket({});
},[alert.newTicket])
  const { roles } = useRoleContext();
  const navigate = useNavigate();
  const [modal, setModal] = useState({ open: false, formElement: null });
  const [externalSubmit, setExternalSubmit] = useState(false);

  const fetchData = async () => {
    try {
      const updatedTickets_ = await fetchTicketStatus({});
      return updatedTickets_;
    } catch (error) {
      console.error(error);
    }
  };

  const refreshTable = () => {
    setTimeout(async () => {
      await fetchData().then((res) => {
        if (res) {
          setTickets(res);
        }
      });
    }, 500);
  };

  const updateTicket = (ticket, state) => {
    ticket.actualStatus = state;
  };

  const handleCloseFeeDialog = () => {
    setIsFeeDialogOpen(false); // Function to close the dialog
  };

  const handleExternalSubmit = async (submitting, closeModal = false) => {
    if (submitting) {
      setExternalSubmit(true);
    } else {
      if (closeModal) {
        handleClose();
        setShowNewTicketForm(false);
      }
      setshowReassignTicketForm(false);
      setExternalSubmit(false);
    }
    // const timeoutId = setTimeout(() => {
    //   // Call your function here
    //   refreshTable();
    // }, 1100);
  };

  const handleExternalFilterSubmit = async (closeModal = false, response) => {
    if (closeModal) {
      setTickets(response);
      setFilterDialogOpen(false);
      setExternalSubmit(false);
    }
  };

  const AllTickets = useRouteLoaderData("board-detail");

  useEffect(() => {
    if (searchText !== "") {
      setTickets((prev) => [
        ...prev.filter((ticket) => {
          console.log(ticket);
          return ticket.itemSnAssociated.includes(searchText);
        }),
      ]);
    } else {
      if(AllTickets.Tickets && AllTickets.Tickets.length>0){
      const filteredTickets = AllTickets.Tickets.filter(
        (t) => typeof t !== "string"
      );
      setTickets(filteredTickets);

      filteredTickets.forEach((ticket) => {
        setSites((prevArray) =>
          prevArray.some((s) => s.id === ticket.siteId)
            ? [...prevArray]
            : [
                ...prevArray,
                { id: ticket.siteId, name: ticket.siteNameAssociated },
              ]
        );
        setBuildings((prevArray) =>
          prevArray.some((b) => b.id === ticket.buildingId)
            ? [...prevArray]
            : [
                ...prevArray,
                { id: ticket.buildingId, name: ticket.buildingNameAssociated },
              ]
        );
        setAssets((prevArray) =>
          prevArray.some((a) => a.id === ticket.assetSnAssociated)
            ? [...prevArray]
            : [
                ...prevArray,
                {
                  id: ticket.assetSnAssociated,
                  name: ticket.assetNameAssociated,
                },
              ]
        );
        setMntEmails((prevArray) =>
          prevArray.some((email) => email === ticket.mntOperatorEmail)
            ? [...prevArray]
            : [...prevArray, ticket.mntOperatorEmail]
        );
        
        // setOperators((prevArray) =>
        //   prevArray.some((a) => a.id === ticket.operator.id)
        //     ? [...prevArray]
        //     : [
        //         ...prevArray,
        //         {
        //           id: ticket.operator.id,
        //           name:
        //             ticket.operator.firstName + " " + ticket.operator.lastName,
        //         },
        //       ]
        // );
      });
    }
  }
  }, [searchText, AllTickets.Tickets]);

  const handleTicketClick = (ticket) => {
    setSelectedTicket(ticket);
    const cardPriority = document.querySelector(
      `.actualImpactType.${ticket.actualImpactType.toLowerCase()}`
    );
    if (cardPriority) {
      cardPriority.parentNode.classList.add("selected");
    }
  };

  const handleClose = () => {
    // setSelectedTicket(null);
  };

  // Callback function to confirm the delete in child component
  const handleConfirmChange = () => {
    const status = detailTicket.actualStatus;
    switch (status) {
      case TicketStatus.OPEN:
        handleConfirmVisualized();
        break;
      case TicketStatus.INPROGRESS:
        handleConfirmSolved();
        break;
      case TicketStatus.PENDINGAPPROVAL:
        if(regress) {
          handleConfirmVisualized();
          setRegress(false)
        }else{
        handleConfirmApproved();}
        break;
      default:
        alert.setError((prev) => [
          ...prev,
          {
            status: true,
            messages: "Error in updating...",
            index: prev.length,
          },
        ]);
        break;
    }
    //refreshTable();
  };

  const handleFeeChange = (newState) => {
    if (newState === true) {
      setDetailOpen(true);
      setDetailText(
        "Are you sure you want to mark this ticket as Issue Solved?"
      );
    }
  };

  const handleVisualized = (ticket,regress) => {
    setDetailOpen(true);
    setDetailTicket(ticket);
    setDetailText(
      'Could you kindly verify your intention to designate this ticket as "ACKNOWLEDGED"?'
    );
    if(regress){
      setRegress(regress)
    }
  };

  const handleConfirmVisualized = async () => {
    var message = "Ticket updated successfully!";
    const updatedTicket = UpdateTicketState(detailTicket, 2, "In progress");
    var response = await updateTicketStatus(updatedTicket);
    console.log("submit:" + JSON.stringify(response));
    if (response.success) {
      //  updateTicket(ticket,"In progress");
      //refreshTable();

      alert.setSuccess((prev) => [
        ...prev,
        {
          status: true,
          message: message,
          index: prev.length,
        },
      ]);
    } else {
      alert.setError((prev) => [
        ...prev,
        { status: true, messages: response.errors, index: prev.length },
      ]);
    }
    setDetailOpen(false);
  };

  const handleSolved = async (ticket) => {
    setTicketToSolve(ticket);
    setDetailTicket(ticket);
    if (ticket.isOnerous && !ticket.feeAmountProposal) {
      setIsFeeDialogOpen(true);
    } else if (!ticket.isOnerous) {
      setFee(1);
      setDetailOpen(true);
      setDetailText(
        "Are you sure you want to mark this ticket as Issue Solved?"
      );
    } else if (ticket.feeAmountProposal) {
      setFee(ticket.feeAmountProposal);
      setDetailOpen(true);
      setDetailText(
        "Are you sure you want to mark this ticket as Issue Solved?"
      );
    }
  };

  const handleConfirmSolved = async () => {
    var message = "Ticket updated successfully!";
    if (fee) {
      var message = "Ticket updated successfully!";
      const updatedTicket = UpdateTicketState(
        ticketToSolve,
        3,
        "Pending approval"
      );
      updatedTicket["feeAmountProposal"] = parseFloat(
        parseFloat(fee).toFixed(2)
      );
      var response = await updateTicketStatus(updatedTicket);
      console.log("submit:" + JSON.stringify(response));
      if (response.success) {
        //  updateTicket(ticket,"In progress");
        //refreshTable();

        alert.setSuccess((prev) => [
          ...prev,
          {
            status: true,
            message: message,
            index: prev.length,
          },
        ]);
      } else {
        alert.setError((prev) => [
          ...prev,
          { status: true, messages: response.errors, index: prev.length },
        ]);
      }
    }
    setFee(null);
    setDetailOpen(false);
  };

  const handleApproved = (ticket) => {
    setDetailOpen(true);
    setDetailTicket(ticket);
    setDetailText("Are you sure you want to CLOSE this ticket ?");
  };

  const handleConfirmApproved = async () => {
    var message = "Ticket updated successfully!";
    const updatedTicket = UpdateTicketState(detailTicket, 4, "Closed");
    var response = await updateTicketStatus(updatedTicket);
    console.log("submit:" + JSON.stringify(response));
    if (response.success) {
      // updateTicket(ticket,"Closed");
      //refreshTable();
      alert.setSuccess((prev) => [
        ...prev,
        {
          status: true,
          message: message,
          index: prev.length,
        },
      ]);
    } else {
      alert.setError((prev) => [
        ...prev,
        { status: true, messages: response.errors, index: prev.length },
      ]);
    }
    setDetailOpen(false);
  };

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const handleSortChange = (e) => {
    const option = e.target.value;
    setSortOption(option);

    const sortedTickets = [...tickets];

    if (option === "date") {
      sortedTickets.sort(
        (a, b) => new Date(a.statusDate) - new Date(b.statusDate)
      );
    } else if (option === "name") {
      sortedTickets.sort((a, b) => {
        const itemA = a.itemSnAssociated || ""; // Use an empty string as fallback
        const itemB = b.itemSnAssociated || ""; // Use an empty string as fallback
        return itemA.localeCompare(itemB);
      });
    }

    setTickets(sortedTickets);
  };

  const handleAddTicket = () => {
    setShowNewTicketForm(true);
  };
  const handleReassignTicket = () => {
    setshowReassignTicketForm(true);
  };

  const handleCancelNewTicket = () => {
    setShowNewTicketForm(false);
    setshowReassignTicketForm(false);
  };

  const handleOpenTicketDetails = (ticket) => {
    setSelectedTicketDetails(ticket);
    setShowTicketDetails(true);
  };

  const handleCloseTicketDetails = () => {
    setShowTicketDetails(false);
  };

  const handleFilterClick = () => {
    setFilterDialogOpen(true);
  };

  const getColumnTicketCount = (status) => {
    return tickets.length
      ? tickets.filter((ticket) => ticket.actualStatus === status).length
      : [];
  };

  useEffect(() => {
 console.log(tickets.length,"updayedddd")
  }, [tickets]);


  return (
    <div className="TicketingPage">
      <Grid container className="buttons-bar" justifyContent={"space-between"}>
        <Grid item xs={12} sm={2}>
          <div className="addNewTicket">
            <ButtonPolicy
              variant="contained"
              onClick={handleAddTicket}
              policy="ticket.add"
            >
              Add New Ticket
            </ButtonPolicy>
          </div>
        </Grid>
        <Grid item xs={12} sm={3}>
          <div className="searchBar">
            <input
              type="text"
              placeholder="Search"
              value={searchText}
              onChange={handleSearchChange}
            />
          </div>
        </Grid>
        <Grid item xs={12} sm={2}>
          <div className="filterTickets">
            <ButtonPolicy variant="contained" onClick={handleFilterClick}>
              filter
            </ButtonPolicy>
          </div>
        </Grid>
        <Grid item xs={12} sm={2}>
          <div className="addNewTicket">
            <ButtonPolicy
              variant="contained"
              onClick={handleReassignTicket}
              policy="ticket.edit"
            >
              Reassign Ticket
            </ButtonPolicy>
          </div>
        </Grid>
        <Grid item xs={12} sm={2}>
          <div className="sortBy">
            <FormControl>
              <InputLabel>Sort By</InputLabel>
              <Select value={sortOption} onChange={handleSortChange}>
                <MenuItem value="date">Date</MenuItem>
                <MenuItem value="name">Name</MenuItem>
              </Select>
            </FormControl>
          </div>
        </Grid>
      </Grid>
      <Grid container className="ticket-container">
        <Grid item xs={12} sm={6} md={3}>
          <div className="column">
            <div className="columnTitle">
              Open{" "}
              <span className="ticketCount">
                {getColumnTicketCount("Open")}
              </span>
            </div>
            <div className="ticketColumn">
              {tickets && tickets.length> 0 && tickets
                .filter((ticket) => ticket.actualStatus === "Open")
                .map((ticket) => (
                  <div key={ticket.id} className="ticket-card">
                    <div className="cardTitle"> {ticket.itemSnAssociated}</div>
                    <div className="cardDescription text-truncate">
                      {ticket.description}
                    </div>
                    <div className="cardDetails">
                      <div className="cardPriority">
                        <span
                          className={`priority ${ticket.actualStatus.toLowerCase()} ${ticket.actualImpactType.toLowerCase()}`}
                        >
                          {ticket.actualImpactType}
                        </span>
                      </div>
                      <div className="cardDate">
                        {moment(ticket.statusDate).format(
                          "YYYY-MM-DD - HH:mm:ss"
                        )}
                      </div>
                    </div>
                    <div className="buttonsDetails">
                      <div className="cardButtons">
                        <div className="cardOpen">
                          <ButtonPolicy
                            variant="contained"
                            onClick={() => handleOpenTicketDetails(ticket)}
                            policy="ticket.view"
                          >
                            View
                          </ButtonPolicy>
                        </div>
                        <div className="cardAction">
                          <ButtonPolicy
                            variant="contained"
                            onClick={() => handleVisualized(ticket)}
                            policy="ticket.edit"
                          >
                            M.O Ack
                          </ButtonPolicy>
                        </div>
                      </div>
                      {selectedTicket && selectedTicket.id === ticket.id && (
                        <div>
                          <button onClick={handleClose}>Close</button>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <div className="column">
            <div className="columnTitle">
              In Progress{" "}
              <span className="ticketCount">
                {getColumnTicketCount("In progress")}
              </span>
            </div>
            <div className="ticketColumn">
              {tickets && tickets.length> 0 && tickets
                .filter((ticket)=> ticket.actualStatus === "In progress")
                .map((ticket) => (
                  <div
                    key={ticket.id}
                    className="ticket-card"
                    onClick={() => handleTicketClick(ticket)}
                  >
                    <div className="cardTitle">{ticket.itemSnAssociated}</div>
                    <div className="cardDescription text-truncate">
                      {ticket.description}
                    </div>
                    <div className="cardDetails">
                      <div className="cardPriority">
                        <span
                          className={`priority progress ${ticket.actualImpactType.toLowerCase()}`}
                        >
                          {ticket.actualImpactType}
                        </span>
                      </div>
                      <div className="cardDate">
                        {moment(ticket.statusDate).format(
                          "YYYY-MM-DD - HH:mm:ss"
                        )}
                      </div>
                    </div>
                    <div className="cardButtons">
                      <div className="cardOpen">
                        <ButtonPolicy
                          variant="contained"
                          onClick={() => handleOpenTicketDetails(ticket)}
                          policy="ticket.edit"
                        >
                          View
                        </ButtonPolicy>
                      </div>
                      <div className="cardAction">
                        <ButtonPolicy
                          variant="contained"
                          onClick={() => handleSolved(ticket)}
                          policy="ticket.edit"
                        >
                          Resolve
                        </ButtonPolicy>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <div className="column">
            <div className="columnTitle">
              Waiting for Approval{" "}
              <span className="ticketCount">
                {getColumnTicketCount("Pending approval")}
              </span>
            </div>
            <div className="ticketColumn">
              {tickets && tickets.length> 0 && tickets
                .filter((ticket)=> ticket.actualStatus === "Pending approval")
                .map((ticket) => (
                  <div
                    key={ticket.id}
                    className="ticket-card"
                    onClick={() => handleTicketClick(ticket)}
                  >
                    <div className="cardTitle">{ticket.itemSnAssociated}</div>
                    <div className="cardDescription text-truncate">
                      {ticket.description}
                    </div>
                    <div className="cardDetails">
                      <div className="cardPriority">
                        <span
                          className={`priority approval ${ticket.actualImpactType.toLowerCase()}`}
                        >
                          {ticket.actualImpactType}
                        </span>
                      </div>
                      <div className="cardDate">
                        {moment(ticket.statusDate).format(
                          "YYYY-MM-DD - HH:mm:ss"
                        )}
                      </div>
                    </div>
                    <div className="cardButtons">
                      <div className="cardOpen">
                        <ButtonPolicy
                          variant="contained"
                          onClick={() => handleVisualized(ticket,true)}
                          policy="ticket.edit"
                        >
                          Regress
                        </ButtonPolicy>
                      </div>
                      <div className="cardAction">
                        <ButtonPolicy
                          variant="contained"
                          onClick={() => handleApproved(ticket)}
                          policy="ticket.edit"
                        >
                          CLOSE T.
                        </ButtonPolicy>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <div className="column">
            <div className="columnTitle">
              Closed{" "}
              <span className="ticketCount">
                {getColumnTicketCount("Closed")}
              </span>
            </div>
            <div className="ticketColumn">
              {tickets && tickets.length> 0 && tickets
                .filter((ticket) => ticket.actualStatus === "Closed")
                .map((ticket) => (
                  <div key={ticket.id} className="ticket-card">
                    <div className="cardTitle">{ticket.itemSnAssociated}</div>
                    <div className="cardDescription text-truncate">
                      {ticket.description}
                    </div>
                    <div className="cardDetails">
                      <div className="cardPriority">
                        <span
                          className={`priority closed ${ticket.actualImpactType.toLowerCase()}`}
                        >
                          {ticket.actualImpactType}
                        </span>
                      </div>
                      <div className="cardDate">
                        {moment(ticket.statusDate).format(
                          "YYYY-MM-DD - HH:mm:ss"
                        )}
                      </div>
                    </div>
                    <div className="cardButtons">
                      <div className="cardOpen">
                        <ButtonPolicy
                          variant="contained"
                          onClick={() => handleOpenTicketDetails(ticket)}
                          policy="ticket.view"
                        >
                          Open
                        </ButtonPolicy>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </Grid>
      </Grid>
      <Dialog
        open={filterDialogOpen}
        onClose={() => setFilterDialogOpen(false)}
      >
        <DialogTitle>Filter Tickets</DialogTitle>
        <DialogContent>
          <TicketFilter
            props={{
              onSubmit: handleExternalFilterSubmit,
              externalSubmit: externalSubmit,
              buildings: buildings,
              sites: sites,
              assets: assets,
              operators: operators,
              mntEmails: mntEmails,
            }}
          />
        </DialogContent>
        <DialogActions>
          <ButtonPolicy
            onClick={() => setExternalSubmit(true)}
            variant="contained"
            className="submitFilters"
            policy="ticket.view"
          >
            Apply Filters
          </ButtonPolicy>
        </DialogActions>
      </Dialog>
      <ProposeFee
        open={isFeeDialogOpen}
        onClose={handleCloseFeeDialog}
        setFee={setFee}
        onToggleFee={handleFeeChange}
      />
      {showNewTicketForm && (
        <Dialog open={true} onClose={handleCancelNewTicket} className="dialog">
          <DialogTitle>Add New Ticket</DialogTitle>
          <DialogContent>
            <Ticket
              props={{
                custom: true,
                onSubmit: handleExternalSubmit,
                externalSubmit: externalSubmit,
                ticketData: selectedTicket,
              }}
            />
          </DialogContent>
          <DialogActions>
            <div className="cancelButton">
              <ButtonPolicy
                onClick={() => handleCancelNewTicket()}
                variant="text"
                policy="ticket.edit"
              >
                Cancel
              </ButtonPolicy>
            </div>

            <div className="addButton">
              <ButtonPolicy
                variant="text"
                onClick={() => handleExternalSubmit(true)}
                policy="ticket.edit"
              >
                {/* <ButtonPolicy variant="text"> */}
                submit
              </ButtonPolicy>
            </div>
          </DialogActions>
        </Dialog>
      )}
      {showReassignTicketForm && (
        <Dialog open={true} onClose={handleCancelNewTicket} className="dialog">
          <DialogTitle>
            {" "}
            Tickets can only be reassigned if in status Open{" "}
          </DialogTitle>
          <DialogContent>
            <ReassignTicket
              props={{
                custom: true,
                onSubmit: handleExternalSubmit,
                externalSubmit: externalSubmit,
                ticketData: tickets,
              }}
            />
          </DialogContent>
          <DialogActions>
            <div className="cancelButton">
              <ButtonPolicy
                onClick={() => handleCancelNewTicket()}
                variant="text"
                policy="ticket.edit"
              >
                Cancel
              </ButtonPolicy>
            </div>

            <div className="addButton">
              <ButtonPolicy
                variant="text"
                onClick={() => handleExternalSubmit(true)}
                policy="ticket.edit"
              >
                {/* <ButtonPolicy variant="text"> */}
                submit
              </ButtonPolicy>
            </div>
          </DialogActions>
        </Dialog>
      )}
      <Dialog open={showTicketDetails} onClose={handleCloseTicketDetails}>
        {selectedTicketDetails && (
          <>
            <DialogTitle>{selectedTicketDetails.itemSnAssociated}</DialogTitle>
            <DialogContent>
              <p>{selectedTicketDetails.description}</p>
              <p>
                Date:{" "}
                {moment(selectedTicketDetails.statusDate).format(
                  "YYYY-MM-DD - HH:mm:ss"
                )}
              </p>
              <p>Priority: {selectedTicketDetails.actualImpactType}</p>
              <p>Status: {selectedTicketDetails.actualStatus}</p>
              {/* <p>
                Assigned to: {selectedTicketDetails.operator.firstName}{" "}
                {selectedTicketDetails.operator.lastName}
              </p> */}
              <p> Email of Operator: {selectedTicketDetails.mntOperatorEmail}</p>
            </DialogContent>
            <DialogActions>
              <div className="closeDialog">
                <ButtonPolicy
                  variant="contained"
                  onClick={handleCloseTicketDetails}
                  policy="ticket.view"
                >
                  Close
                </ButtonPolicy>
              </div>
            </DialogActions>
          </>
        )}
      </Dialog>
      {detailOpen && (
        <DailogContainer
          detailOpen={detailOpen}
          setDetailOpen={setDetailOpen}
          text={detailText}
          onToggleChange={handleConfirmChange}
        />
      )}
    </div>
  );
};

export default TicketingPage;
async function loadTickets() {
  const response = await fetchTicketStatus({});
  return response;
}
export async function loader() {
  return defer({
    Tickets: await loadTickets(),
  });
}
